import { useEffect, useRef } from "react";

export default function EyeMark({ size = 40, className = "" }) {
    const irisRef = useRef(null);
    const rootRef = useRef(null);

    useEffect(() => {
        const pos = { x: 0, y: 0 };
        const target = { x: 0, y: 0 };
        let raf;
        let lastMove = 0;
        let t = Math.random() * 100;

        const onMove = (e) => {
            const rect = rootRef.current?.getBoundingClientRect();
            if (!rect) return;
            lastMove = Date.now();
            const cx = rect.left + rect.width / 2;
            const cy = rect.top + rect.height / 2;
            const dx = e.clientX - cx;
            const dy = e.clientY - cy;
            const dist = Math.hypot(dx, dy) || 1;
            const pull = Math.min(dist / 60, 1);
            target.x = (dx / dist) * 5.5 * pull;
            target.y = (dy / dist) * 3 * pull;
        };

        const loop = () => {
            t += 0.016;
            if (Date.now() - lastMove > 2500) {
                target.x = Math.sin(t * 0.7) * 4;
                target.y = Math.cos(t * 0.5) * 1.6;
            }
            pos.x += (target.x - pos.x) * 0.07;
            pos.y += (target.y - pos.y) * 0.07;
            irisRef.current?.setAttribute(
                "transform",
                `translate(${pos.x.toFixed(2)} ${pos.y.toFixed(2)})`
            );
            raf = requestAnimationFrame(loop);
        };

        window.addEventListener("mousemove", onMove, { passive: true });
        raf = requestAnimationFrame(loop);
        return () => {
            window.removeEventListener("mousemove", onMove);
            cancelAnimationFrame(raf);
        };
    }, []);

    return (
        <svg
            ref={rootRef}
            viewBox="0 0 100 100"
            width={size}
            height={size}
            className={className}
            role="img"
            aria-label="Vantage Crest Research emblem"
            data-testid="brand-eye-mark"
        >
            <circle cx="50" cy="50" r="48" fill="#102A4C" />
            <circle
                cx="50"
                cy="50"
                r="47"
                fill="none"
                stroke="#C9A24B"
                strokeOpacity="0.4"
                strokeWidth="1"
            />
            <g className="eye-blink">
                <path
                    d="M26 50 Q50 32 74 50 Q50 68 26 50 Z"
                    fill="none"
                    stroke="#F6F4EF"
                    strokeWidth="3.4"
                />
                <polygon points="50,37 38.5,60 61.5,60" fill="#C9A24B" />
                <g ref={irisRef}>
                    <circle cx="50" cy="52" r="7.2" fill="#F6F4EF" />
                    <circle cx="50" cy="52" r="2.7" fill="#102A4C" />
                </g>
            </g>
        </svg>
    );
}
